import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import './index.scss';
import TableUser from '../../components/TableUser';
import Button from "../../common/Button";
import MSGDialogue from '../../components/Dialogue';
import axios from 'axios';
import { APIurl } from '../../App';

export default function Adduser() {

  /* ================= STATE ================= */
  const [username, setUsername] = useState("");
  const [tradeName, setTradeName] = useState("");
  const [password, setPassword] = useState("");

  const [errUsername, setErrUsername] = useState("");
  const [errPassword, setErrPassword] = useState("");

  const [loginmsg, setLogingmsg] = useState("");
  const [colors, setColors] = useState("");
  const [diaglogueID] = useState("msg4");
  const [logging, setLogging] = useState(false);

  const [members, setMembers] = useState([]);

  /* ================= TABLE ================= */
  const table_headers = [
    { id: 1, name: "ID" },
    { id: 2, name: "Username" },
    { id: 3, name: "Trade Name" },
    { id: 4, name: "Status" },
    { id: 5, name: "Manage" }
  ];

  const buttons = [{ id: 1, title: "Export CSV", path: "exportusers" }];

  /* ================= AUTO HIDE MESSAGE ================= */
useEffect(() => {

  const email = localStorage.getItem("email");

  axios.post(APIurl, {
    cmd: "getallusers",
    username: email
  })
  .then(res => {
    if (res.data.success) {
      setMembers(res.data.data);
    }
  })
  .catch(() => {
    console.error("Failed to load users");
  });
}, []);

  /* ================= SUBMIT ================= */
  const process = () => {
    setLogging(false);
    setLogingmsg("");

    let ok = true;

    if (!username) {
      setErrUsername("Email cannot be empty");
      ok = false;
    } else {
      setErrUsername("");
    }

    if (!password) {
      setErrPassword("Password cannot be empty");
      ok = false;
    } else {
      setErrPassword("");
    }

    if (!ok) return;

    axios.post(APIurl, {
     cmd: "adduser",
  username,
  pasword: password,
  trade_name: tradeName,
  owner: localStorage.getItem("email")
    })
    .then((response) => {
      const res = response.data;

      if (!res.success) {
        setLogingmsg(res.data);
        setColors("text-white bg-danger");
      } else {
        setLogingmsg("App user created successfully");
        setColors("text-white bg-success");
        setMembers(res.data ?? []);
        setUsername("");
        setTradeName("");
        setPassword("");
      }

      setLogging(true);
    })
    .catch(() => {
      setLogingmsg("Server error occurred");
      setColors("text-white bg-danger");
      setLogging(true);
    });
  };

  /* ================= UI ================= */
  return (
    <>
      {logging && (
        <MSGDialogue
          msg={loginmsg}
          id={diaglogueID}
          colors={colors}
        />
      )}

      <div className='mr-0 ml-0 p-2 mt-2 mb-0'>
        <h3>Create App User</h3>
      </div>

      <Container fluid className='d-flex flex-row mt-2 w-100 home-cards'>
        <div className='login-container mx-auto my-3 p-3 bg-white rounded animate__animated animate__fadeInDown'>

          <div className="theme-color h3 text-center">
            Add App User / Client
          </div>
          <hr />

          {/* EMAIL */}
          <div className='form-group my-2 mx-1'>
            <input
              className='form-control'
              placeholder='Enter Email'
              type="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <span className='text-danger'>{errUsername}</span>
          </div>

          {/* TRADE NAME */}
          <div className='form-group my-2 mx-1'>
            <input
              className='form-control'
              placeholder='Enter Trade Name'
              type="text"
              value={tradeName}
              onChange={(e) => setTradeName(e.target.value)}
            />
          </div>

          {/* PASSWORD */}
          <div className='form-group my-2 mx-1'>
            <input
              className='form-control'
              placeholder='Enter Password'
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span className='text-danger'>{errPassword}</span>
          </div>

          <Button
            icon="fa fa-user"
            title="Add User"
            active="btn-deactive my-3"
            action={process}
          />
        </div>
      </Container>

      <TableUser
        name="Users"
        edit="edituser"
        delete="/userdelete"
        table_headers={table_headers}
        members={members}
        buttons={buttons}
      />
    </>
  );
}
